// extracted by mini-css-extract-plugin
export var contentContainerOuter = "case-study-layout-module--contentContainerOuter--974fc";
export var contentDescription = "case-study-layout-module--contentDescription--9b0c5";
export var contentTitle = "case-study-layout-module--contentTitle--4fbf7";
export var contentType = "case-study-layout-module--contentType--2c1f2";
export var ctaContainer = "case-study-layout-module--ctaContainer--172d8";
export var heroContentContainer = "case-study-layout-module--heroContentContainer--747b0";
export var heroLayoutContainer = "case-study-layout-module--heroLayoutContainer--0a70e";
export var moduleContainer = "case-study-layout-module--moduleContainer--40aa5";
export var overviewCard = "case-study-layout-module--overviewCard--68f2e";
export var overviewCards = "case-study-layout-module--overviewCards--43f4b";
export var overviewContainer = "case-study-layout-module--overviewContainer--6b05c";
export var reactPlayer = "case-study-layout-module--reactPlayer--19115";
export var stat = "case-study-layout-module--stat--5a118";
export var stats = "case-study-layout-module--stats--4a20e";
export var statsContainer = "case-study-layout-module--statsContainer--d423e";
export var statsTitle = "case-study-layout-module--statsTitle--65713";